<template>
  <div class="service-page">
    <!-- <van-nav-bar title="新手教程"
      left-arrow
      @click-left="onClickLeft"
    /> -->
    <div class="marginTop">
      <div
        v-for="(item, index) in linkList"
        :key="index"
        @click="jumpToAgreement(item.link)"
      >
        <van-cell :title="item.title" is-link></van-cell>
      </div>
    </div>
  </div>
</template>
<script>
import { getCookie } from '@/utils/auth'
import {getNewCourse} from '@/api/index'
export default {
  data() {
    return {
      apiList:[] ,// 调用接口获取 配置的新手教程地址
      linkList: []
    }
  },
  created() {
    this.getList() ;
  },
  methods: {
    /**
    * @description: 跳协议页
    * @param {number} 协议编号
    * @return: void
    */
    jumpToAgreement(url) {
      if(url == "qualificationImage"){
        this.$router.push('/qualificationImage')
      }else{
        window.location.href = url
      }
    },
    async getList(){
      let ans = [{
        title: "电脑端操作指南",
        link: "https://mp.weixin.qq.com/s/Gl8VXSBVF3VuXLZ1kVVmVA"
      }, {
        title: "手机端操作指南",
        link: "https://mp.weixin.qq.com/s/fxaumq_mGDzu_v-X3O7uXA"
      }, {
        title: "远程审方操作指南",
        link: "https://mp.weixin.qq.com/s/w-udpCIagK_POgvV7CYjrg"
      }, {
        title: "调配发药签名指南",
        link: "https://mp.weixin.qq.com/s/FVLCQRPXwZaGKe6ws1ivbA"
      }, {
        title: "扫码问诊操作指南",
        link: "https://mp.weixin.qq.com/s/ECtwx9R1ytL-tMZ-wnobuw"
      }, {
        title: "药师手机端操作指南",
        link: "https://mp.weixin.qq.com/s/qpPknQaLldyLxWWcDY6l7g"
      },{
        title: "药师CA认证",
        link: "http://clk.ybm100.com"
      }, {
        title: "常见问题解答",
        link: "https://mp.weixin.qq.com/s/qIssgDga-WQoSLdWjJJ5HQ"
      }, {
        title: "发票申请",
        link: "https://www.wjx.cn/jq/87997429.aspx"
      },  {
        title: "互联网医院资质图片",
        link: process.env.VUE_APP_TITLE === 'production' ? "https://tuan-activity.ybm100.com/#/qualification" : 
        "https://tuan-activity.test.ybm100.com/#/qualification"
      }]
      try {
        let res = await getNewCourse({}) ; 
        console.log("新手教程---",res) ; 
        if(res.data.code == 0){
          this.apiList = res.data.result ; 
          // 根据调用接口获取到的列表 和 默认的列表进行比对 如果获取的列表中 有 title 和默认列表相等 则需要将原有列表的url替换成获取列表的url
          //  如果没有匹配则该项添加到原有列表的最后
          let list = [] ; 
           this.linkList = ans ;
          this.apiList.forEach((item,index) => {
            let flag = false ; 
            this.linkList.forEach((item2,idx) => {
              console.log(item,"---",item2,item.title == item2.title)
              if(item.title == item2.title){
                console.log("---------相等1" ,item)
                flag = true ;
                this.linkList[idx].link = item.tutorialUrl
                console.log("---------相等1" ,item)

              }
            })
            if(!flag) {
              // 没有在默认列表说明是新增的
              list.push({
                title:item.title,
                link:item.tutorialUrl
              }) ; 
            }
          })  
          this.linkList = [...this.linkList,...list] ; 
          console.log(this.linkList) ;
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>
<style scoped>
#app {
  height: 100vh;
}
.service-page {
  width: 375px;
  height: 100vh;
  background: #f7f7f7;
  position: relative;
}
.infoBox {
  display: flex;
  align-items: center;
  font-size: 14px;
  background: #fff;
  padding: 15px;
}
.infoImg {
  width: 50px;
  height: 50px;
  background: #3d7eff;
  text-align: center;
  line-height: 50px;
  border-radius: 50%;
  margin-right: 15px;
  color: #fff;
}
.infoBox img {
  width: 50px;
  height: 50px;
  background: #3d7eff;
  border-radius: 50%;
  margin-right: 15px;
}
.infoBox .smSize {
  color: #666;
  font-size: 12px;
}
.marginTop {
  margin-top: 10px;
  font-size: 14px;
}
.logout {
  width: 100%;
  background: white;
  text-align: center;
  color: red;
  font-size: 14px;
  padding: 10px 0;
}
.call {
  display: block;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #323233;
  font-size: 16px;
  padding-bottom: 10px;
}
</style>
